import React from 'react';
import CurrencyFormat from 'react-currency-format';

export default function InputCell(props) {
    const { label, defaultValue, inputRef, onChange, required, placeholder, type,
        inputProps, isCurrency, disabled, wrapperClasses, maxLength, minValue, maxValue, onBlur, pattern,
        showRequiredIndicator, blurErrorMessage, id } = props;
    const [inputFocused, setInputFocused] = React.useState(false);
    const [inputVal, setInputVal] = React.useState("");
    const [showBlurError, setShowBlurError] = React.useState(false);

    const errorId = id
        ? `${id}-error`
        : label
            ? `${label.replace(/\s+/g, '-').toLowerCase()}-error`
            : undefined;

    const onInputFocused = () => {
        setInputFocused(true);
        setShowBlurError(false);
    }

    const onInputBlurred = (e) => {
        setInputFocused(false);
        if (blurErrorMessage && !e.target.value.trim()) {
            setShowBlurError(true);
        }
        if (onBlur) {
            onBlur(e);
        }

    }

    const onInputChange = (e) => {
        if (pattern && e.target.value !== "") {
            var regexp = new RegExp(pattern);
            if (!regexp.test(e.target.value)) {
                return;
            }
        }

        setInputVal(e.target.value);
        if (onChange) {
            onChange(e);
        }
    }

    const onCurrencyInputChange = (values) => {
        const { formattedValue, value } = values;
        setInputVal(formattedValue);
        if (onChange) {
            onChange(value);
        }
    }

    React.useEffect(() => {
        if (defaultValue) {
            setInputVal(defaultValue);
        }
    }, [defaultValue]);
    let calculatedType = type ? type : "text";

    const field = () => {
        if (isCurrency) {
            return <CurrencyFormat value={inputVal} onValueChange={onCurrencyInputChange} decimalScale={2} className="input" fixedDecimalScale={true} prefix={'$'} />
        }

        switch (calculatedType) {
            case "textarea": return <textarea disabled={disabled}
                id={id}
                value={inputVal}
                onChange={onInputChange}
                onFocus={onInputFocused}
                onBlur={onInputBlurred}
                //className="input"
                ref={inputRef}
                maxLength={maxLength}
                min={minValue}
                max={maxValue}
                aria-required={required ? "true" : undefined}
                aria-invalid={showBlurError ? "true" : undefined}
                aria-describedby={showBlurError && errorId ? errorId : undefined}
                {...inputProps} />;

            default: return <input disabled={disabled}
                type={calculatedType}
                value={inputVal}
                onChange={onInputChange}
                onFocus={onInputFocused}
                onBlur={onInputBlurred}
                className="input"
                ref={inputRef}
                maxLength={maxLength}
                min={minValue}
                max={maxValue}
                pattern={pattern}
                id={id}
                aria-required={required ? "true" : undefined}
                aria-invalid={showBlurError ? "true" : undefined}
                aria-describedby={showBlurError && errorId ? errorId : undefined}
                placeholder={placeholder ? placeholder : ""} {...inputProps} />;
        }
    }

    return (
        <>
            <div className={`cell inputCell ${disabled ? "disabled" : ""} ${required ? "required" : ""} ${inputFocused ? "isFocused" : ""} ${(inputVal.length > 0) ? "hasInput" : ""} ${wrapperClasses ? wrapperClasses : ""}`}>
                {
                    label ? (
                        <label className="title" htmlFor={id}>
                            {label}
                            {showRequiredIndicator && (
                                <span aria-hidden="true" style={{ color: 'var(--colorRequiredText)', fontSize: '0.75em', position: 'relative', top: '-0.3em', marginLeft: '1px' }}>*</span>
                            )}
                        </label>
                    ) : null
                }

                {field()}
            </div>
            {showBlurError && blurErrorMessage && (
                <div id={errorId} style={{ color: 'var(--colorRequiredText)', fontSize: '0.75em', padding: '4px 0 0 12px' }}>
                    {blurErrorMessage}
                </div>
            )}
        </>
    );
}
